const cards = [
  {
    title: '时空穿梭者：纪元重启',
    tag: '科幻巨制',
    rating: '9.2',
    desc: '未来世界格局崩塌，一群勇者穿越时空修复历史裂痕，震撼视效与深度剧情完美结合。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20futuristic%20cityscape%20and%20time%20portal%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20movie%20poster%20quality&width=600&height=400&seq=card-movie-01&orientation=landscape',
  },
  {
    title: '暗夜追踪者',
    tag: '悬疑推理',
    rating: '8.8',
    desc: '连环案件背后隐藏惊天秘密，硬汉刑警与天才侧写师的极限对决。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20scene%20with%20noir%20aesthetic%2C%20rainy%20city%20street%20at%20night%2C%20detective%20silhouette%2C%20moody%20atmosphere%2C%20film%20noir%20lighting&width=600&height=400&seq=card-movie-02&orientation=landscape',
  },
  {
    title: '夏日的约定',
    tag: '浪漫爱情',
    rating: '8.5',
    desc: '青春校园里的甜蜜约定，跨越十年光阴的温暖守候，治愈系年度力作。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20scene%20in%20summer%20campus%2C%20cherry%20blossoms%2C%20soft%20golden%20sunlight%2C%20young%20couple%20in%20distance%2C%20nostalgic%20film%20aesthetic%2C%20dreamy%20atmosphere&width=600&height=400&seq=card-movie-03&orientation=landscape',
  },
  {
    title: '武林风云录',
    tag: '动作大片',
    rating: '9.0',
    desc: '江湖再起波澜，隐世高手重出江湖，拳拳到肉的极致武打盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20film%20scene%20in%20ancient%20Chinese%20setting%2C%20bamboo%20forest%2C%20dynamic%20action%2C%20flowing%20fabric%2C%20dramatic%20lighting%2C%20wuxia%20aesthetic&width=600&height=400&seq=card-movie-04&orientation=landscape',
  },
  {
    title: '我的机器人室友',
    tag: '爆笑喜剧',
    rating: '8.3',
    desc: '一个笨拙宅男与高智能机器人同居的爆笑日常，笑中带泪的温情故事。',
    img: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20scene%20with%20robot%20and%20human%20in%20modern%20apartment%2C%20bright%20lighting%2C%20quirky%20scenario%2C%20warm%20interior%2C%20comedic%20timing%20moment&width=600&height=400&seq=card-movie-05&orientation=landscape',
  },
  {
    title: '帝国荣耀：浴火重生',
    tag: '高分经典',
    rating: '9.5',
    desc: '史诗级历史巨制，再现帝国兴衰的宏大叙事，不可错过的经典之作。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20scene%20with%20grand%20battle%20and%20ancient%20architecture%2C%20cinematic%20composition%2C%20dramatic%20sky%2C%20warm%20golden%20and%20deep%20crimson%20tones&width=600&height=400&seq=card-movie-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">编辑团队每日精选，好片不迷路</p>
          </div>
          <a
            href="#ranking"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 4 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/70 text-white text-xs font-medium">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-bold">
                  {card.rating}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <a
            href="#ranking"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer no-underline"
          >
            查看全部精选 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}